import DateAndTime from 'views/dateAndTime/DateAndTime.container';

export default DateAndTime;